import React from 'react'

export default ({ ...props }) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      id='search-icon-path'
      d='M18.869 19.162L12.926 12.678C14.265 11.277 15.001 9.445 15.001 7.5C15.001 5.497 14.221 3.613 12.804 2.197C11.387 0.781 9.50398 0 7.50098 0C5.49798 0 3.61398 0.78 2.19798 2.197C0.781977 3.614 0.000976562 5.497 0.000976562 7.5C0.000976562 9.503 0.780977 11.387 2.19798 12.803C3.61498 14.219 5.49798 15 7.50098 15C9.22698 15 10.863 14.421 12.189 13.355L18.132 19.838C18.231 19.946 18.365 20 18.501 20C18.622 20 18.743 19.957 18.839 19.869C19.043 19.682 19.056 19.366 18.87 19.163L18.869 19.162ZM0.999977 7.5C0.999977 3.916 3.91598 1 7.49998 1C11.084 1 14 3.916 14 7.5C14 11.084 11.084 14 7.49998 14C3.91598 14 0.999977 11.084 0.999977 7.5Z'
    />
  </svg>
)
